import type { CookieName } from 'utility/constants';

import Cookies from 'js-cookie';

export const setCookie = (name: CookieName, value: string, options?: Cookies.CookieAttributes) => {
  Cookies.set(name, value, options);
};

export const getCookie = (name: CookieName) => {
  return Cookies.get(name);
};

export const removeCookie = (name: CookieName) => {
  Cookies.remove(name);
};

export const hasCookie = (name: CookieName) => {
  return !!getCookie(name);
};
